enum PhoneType {
    Pager,
    Phone,
    Fax,
    Mobile
}

export { PhoneType };
